import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import DiscussionComposer from 'flarum/forum/components/DiscussionComposer';
import DuplicateWarningModal from './DuplicateWarningModal';
export default function extendDuplicatePrevention() {
  extend(DiscussionComposer.prototype, 'oninit', function () {
    this.duplicateMatches = [];
    this.duplicateLoading = false;
    this.duplicateDismissed = false;
    this.duplicateConfirmed = false;
    this.duplicateCheckTimeout = null;
  });
  DiscussionComposer.prototype.triggerDuplicateCheck = function (titleVal) {
    if (this.duplicateCheckTimeout) {
      clearTimeout(this.duplicateCheckTimeout);
    }
    const cleanTitle = (titleVal || '').trim();
    if (cleanTitle.length < 4) {
      this.duplicateMatches = [];
      this.duplicateLoading = false;
      m.redraw();
      return;
    }

    // Skip checking if title only consists of generic club words (e.g. "Athletic", "Athletic Club", "Bilbao")
    const genericWords = ['athletic', 'club', 'bilbao', 'zurigorri', 'leones', 'sanmames', 'real', 'sociedad', 'reala', 'txuri', 'urdin', 'donostia'];
    const words = cleanTitle.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, ' ').trim().split(/\s+/).filter(w => w.length >= 3);
    const meaningfulWords = words.filter(w => !genericWords.includes(w));
    if (meaningfulWords.length === 0) {
      this.duplicateMatches = [];
      this.duplicateLoading = false;
      m.redraw();
      return;
    }
    this.duplicateCheckTimeout = setTimeout(async () => {
      this.duplicateLoading = true;
      m.redraw();
      try {
        const response = await app.request({
          method: 'GET',
          url: "".concat(app.forum.attribute('apiUrl'), "/nagusi/check-duplicates"),
          params: {
            title: cleanTitle
          },
          errorHandler: () => {
            // Duplicate prevention is strictly optional: fail completely silently without disturbing the user
          }
        });
        this.duplicateMatches = (response == null ? void 0 : response.matches) || [];
        this.duplicateDismissed = false;
      } catch (e) {
        // Fail silently
        this.duplicateMatches = [];
      } finally {
        this.duplicateLoading = false;
        m.redraw();
      }
    }, 400);
  };
  override(DiscussionComposer.prototype, 'headerItems', function (original) {
    const items = original();

    // Keep discussionTitle as standard <h3><input /></h3> without extra wrapper div
    items.replace('discussionTitle', m("h3", null, m("input", {
      className: "FormControl",
      value: this.title(),
      placeholder: this.attrs.titlePlaceholder,
      disabled: !!this.attrs.disabled,
      onkeydown: this.onkeydown.bind(this),
      oninput: e => {
        const val = e.target.value;
        this.title(val);
        this.triggerDuplicateCheck(val);
      }
    })));

    // Add duplicatePreventionAlert as separate header item only when matches exist
    if (!this.duplicateDismissed && Array.isArray(this.duplicateMatches) && this.duplicateMatches.length > 0) {
      items.add('duplicatePreventionAlert', m("div", {
        className: "DuplicatePreventionAlert"
      }, m("div", {
        className: "DuplicatePreventionAlert-header"
      }, m("span", null, m("i", {
        className: "fas fa-info-circle DuplicatePreventionAlert-icon"
      }), m("strong", null, app.translator.trans('nagusi-match-ratings.forum.duplicates.alert_heading') || 'Hilos similares detectados recientemente:'), this.duplicateMatches.length > 1 && m("button", {
        type: "button",
        className: "Button Button--link DuplicatePreventionAlert-viewAllBtn",
        onclick: e => {
          e.preventDefault();
          e.stopPropagation();
          app.modal.show(DuplicateWarningModal, {
            matches: this.duplicateMatches,
            composer: this
          });
        },
        title: "Ver todos los hilos similares"
      }, "(Ver todos)")), m("button", {
        type: "button",
        className: "Button Button--link DuplicatePreventionAlert-dismiss",
        onclick: e => {
          e.preventDefault();
          e.stopPropagation();
          this.duplicateDismissed = true;
        },
        title: "Ocultar aviso"
      }, m("i", {
        className: "fas fa-times"
      }))), m("div", {
        className: "DuplicatePreventionAlert-list"
      }, this.duplicateMatches.slice(0, 3).map(item => m("div", {
        className: "DuplicatePreventionAlert-item",
        key: item.id
      }, m("div", {
        className: "DuplicatePreventionAlert-itemTop"
      }, m("a", {
        href: app.route('discussion', {
          id: "".concat(item.id).concat(item.slug ? '-' + item.slug : '')
        }),
        target: "_blank",
        rel: "noopener noreferrer",
        className: "DuplicatePreventionAlert-link"
      }, m("i", {
        className: "fas fa-external-link-alt",
        style: {
          marginRight: '5px',
          fontSize: '0.85em'
        }
      }), item.title), item.tag && m("span", {
        className: "DuplicatePreventionAlert-tag",
        style: {
          backgroundColor: item.tag.color || '#717171'
        }
      }, item.tag.name)), m("div", {
        className: "DuplicatePreventionAlert-meta"
      }, m("span", null, item.commentCount, " ", item.commentCount === 1 ? 'comentario' : 'comentarios'), m("span", null, " \xB7 "), m("span", null, "Por ", item.lastPostedUser), m("span", {
        className: "DuplicatePreventionAlert-score"
      }, "(", Math.round(item.similarity), "% similar)"))))), m("div", {
        className: "DuplicatePreventionAlert-footer"
      }, m("span", {
        className: "DuplicatePreventionAlert-tip"
      }, "\uD83D\uDCA1 Si tu duda o comentario encaja en alguno de estos hilos, com\xE9ntalo all\xED en lugar de abrir uno nuevo."))), -100);
    }
    return items;
  });

  // Override onsubmit to intercept high-similarity duplicates
  override(DiscussionComposer.prototype, 'onsubmit', function (original) {
    var _this$duplicateMatche;
    const topMatch = (_this$duplicateMatche = this.duplicateMatches) == null ? void 0 : _this$duplicateMatche[0];

    // If similarity >= 75% and user hasn't explicitly confirmed publication
    if (!this.duplicateConfirmed && topMatch && topMatch.similarity >= 75) {
      app.modal.show(DuplicateWarningModal, {
        matches: this.duplicateMatches,
        onConfirm: () => {
          this.duplicateConfirmed = true;
          this.onsubmit();
        }
      });
      return;
    }

    // Call original submission logic
    original();
  });
}
flarum.reg.add('nagusi-match-ratings', 'forum/duplicates/extendDuplicatePrevention', extendDuplicatePrevention);